import React from 'react';
import { Sparkles } from 'lucide-react';
import FloatingButton from 'app/modules/remarks/components/FloatingButton';

export const AskMaxLauncher: React.FC<{
  onClick: () => void;
  live: boolean;
}> = ({ onClick, live }) => (
  <FloatingButton
    onClick={onClick}
    icon={<Sparkles size={22} />}
    buttonText="Ask Max"
    pulse={live}
    stacked
    ariaLabel="Open Ask Max"
  />
);
